import LoadingButton from './LoadingButton'
import styled from 'styled-components'

export default styled(LoadingButton)`
  background: #3399cc;
  font-size: 16px;
  width: 124px;
`
